

function userManagement() {

    let userService = [
        {
            name: "User Mangement",
            icon: "user-management",
            logoName: "user",
            // flag: "voucherRequired",
            displayService: "userManagement",
            items: [],
        },
    ];

    const dashboard = () => {
        const dashboardArr = [
            {
                path: "/index/user-management",
                name: "Dashboard",
                icon: "dashboard",
                logoName: "dashboard",
                flag: "DASHBOARD",
            },
        ];

        return dashboardArr;
    };

    const userMaster = () => {
        const profileArr = [
            {
                path: "/index/BackOffice",
                name: "Back Office",
                icon: "user-master",
                logoName: "userManagement",
                flag: "BACK OFFICE",
            },
        ];

        // if (
        //   constants.visibleFlags.includes(walletSettings.data[profileArr[0].flag])
        // ) {
        return profileArr;
        // } else {
        //   return "";
        // }
    };

    let a = dashboard();
    let b = userMaster();

    userService[0].items = [...a, ...b];

    return userService;
}

export default userManagement;
